import { render } from "./imgMonitor.vue?vue&type=template&id=fb32bed4"
import script from "./imgMonitor.vue?vue&type=script&lang=js"
export * from "./imgMonitor.vue?vue&type=script&lang=js"

import "./imgMonitor.vue?vue&type=style&index=0&id=fb32bed4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__